import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DataClassPathSerializer1pr4zwqha0dv8 as DataClassPathSerializer } from '../serialization/DataClassPathSerializer.mjs';
import {
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
  DataClassPathAccess21fi12r1lk4vq as DataClassPathAccess,
} from '../serialization/DataClassPath.mjs';
import { get_serializableProperties2tbouuwr11am9 as get_serializableProperties } from '../serialization/SerializableProperty.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first1vi3grnpj1175 as first } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { SortPart1gsioxz0aa07v as SortPart } from './SortPart.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  startsWith1bgirhbedtv2y as startsWith,
  removePrefix279df90bhrqqg as removePrefix,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KSerializerWithDefault194z2ragoko00 as KSerializerWithDefault } from '../serialization/Defaults.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function error($this) {
  throw IllegalStateException().o4('Primitive descriptor does not have elements');
}
var SortPartSerializer$descriptor$1Class;
function SortPartSerializer$descriptor$1() {
  if (SortPartSerializer$descriptor$1Class === VOID) {
    class $ {
      constructor() {
        this.v4a_1 = STRING_getInstance();
        this.w4a_1 = 'com.lightningkite.lightningdb.SortPart';
        var tmp = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp.x4a_1 = emptyList();
      }
      s11() {
        return this.v4a_1;
      }
      h10() {
        return this.w4a_1;
      }
      u11() {
        return 0;
      }
      v11(index) {
        error(this);
      }
      w11(name) {
        error(this);
      }
      z11(index) {
        error(this);
      }
      y11(index) {
        error(this);
      }
      x11(index) {
        error(this);
      }
      toString() {
        return 'PrimitiveDescriptor(' + this.w4a_1 + ')';
      }
      bz() {
        return this.x4a_1;
      }
    }
    protoOf($).l11 = get_isNullable;
    protoOf($).t11 = get_isInline;
    initMetadataForClass($, VOID, VOID, VOID, [SerialDescriptor()]);
    SortPartSerializer$descriptor$1Class = $;
  }
  return SortPartSerializer$descriptor$1Class;
}
var SortPartSerializerClass;
function SortPartSerializer() {
  if (SortPartSerializerClass === VOID) {
    class $ {
      constructor(inner) {
        this.y4a_1 = inner;
        var tmp = this;
        tmp.z4a_1 = new (SortPartSerializer$descriptor$1())();
        this.a4b_1 = new (DataClassPathSerializer())(this.y4a_1);
      }
      z3m() {
        return new (SortPart())(new (DataClassPathAccess())(new (DataClassPathSelf())(this.y4a_1), first(ensureNotNull(get_serializableProperties(this.y4a_1)))));
      }
      az() {
        return this.z4a_1;
      }
      pz(decoder) {
        var value = decoder.h13();
        var descending = startsWith(value, _Char___init__impl__6a9atx(45));
        var nameWithoutCase = removePrefix(value, '-');
        var ignoreCase = startsWith(nameWithoutCase, _Char___init__impl__6a9atx(126));
        var name = removePrefix(nameWithoutCase, '~');
        return new (SortPart())(this.a4b_1.a3s(name), !descending, ignoreCase);
      }
      d4b(encoder, value) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().d1();
        if (!value.q4a_1) {
          this_0.xb(_Char___init__impl__6a9atx(45));
        }
        if (value.r4a_1) {
          this_0.xb(_Char___init__impl__6a9atx(126));
        }
        this_0.wb(value.p4a_1.toString());
        var tmp$ret$2 = this_0.toString();
        encoder.p14(tmp$ret$2);
      }
      oz(encoder, value) {
        return this.d4b(encoder, value instanceof SortPart() ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'SortPartSerializer', VOID, VOID, [KSerializerWithDefault()]);
    SortPartSerializerClass = $;
  }
  return SortPartSerializerClass;
}
//region block: exports
export {
  SortPartSerializer as SortPartSerializer1fx0t5bmnpc8h,
};
//endregion

//# sourceMappingURL=SortPartSerializer.mjs.map
